import Backbone from 'backbone';

import {AlignmentSelectionPropsAttributes} from 'constants/AlignmentConstants';

export default class AlignmentSelectionProps extends Backbone.Model {
  override defaults(): AlignmentSelectionPropsAttributes {
    return {
      start: 0,
      end: null,
      anchor: 'start',
      active: false,
      rowIndex: 0,
    };
  }
}
